import React, { useState } from 'react'

import axios from 'axios'

import ShareMenu from '../../components/ShareMenu'

const ShareMenuContainer = ({ url, className, svgColor }) => {
    const [tinyURL, setTinyURL] = useState('')
    const [id, setId] = useState(0)

    // this logic is used from aria-viewer
    const generateID = () => {
        let requestId = 0
        do {
            requestId = Math.round(Math.random() * 1e16)
        } while (requestId < 1e15)
        return requestId
    }

    const copyURL = () => {
        const requestId = generateID()
        axios({
            method: 'post',
            url: `${process.env.REACT_APP_BASE_URL}/main/Home/generateTinyURL?t=${Date.now()}`,
            data: `url=${encodeURIComponent(url)}&requestid=${requestId}`,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        }).then(
            response => {
                setTinyURL(response.data.data.url)
                setId(requestId)
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            error => {
                setTinyURL(null)
                setId(requestId)
            }
        )
    }

    return <ShareMenu className={className} url={url} svgColor={svgColor} copyURL={copyURL} tinyURL={tinyURL} id={id} />
}

ShareMenuContainer.defaultProps = {
    url: undefined,
    svgColor: undefined,
    className: undefined,
}
export default ShareMenuContainer
